import { sameYMD } from '@/shared/tools/dateTime'

const parse = (value?: string | null): Date | null => {
  if (!value) {
    return null
  }

  const date = new Date(value)

  return Number.isNaN(date.getTime()) ? null : date
}

export const formatFrenchDateTime = (value?: string | null): string | null => {
  const date = parse(value)

  return date
    ? date.toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    : null
}

export const formatFrenchTime = (value?: string | null): string | null => {
  const date = parse(value)

  return date ? date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : null
}

// A bare time would be ambiguous once the handover is older than today.
export const formatFrenchSentAt = (value?: string | null): string | null => {
  const date = parse(value)

  if (!date) {
    return null
  }

  return sameYMD(date, new Date()) ? formatFrenchTime(value) : formatFrenchDateTime(value)
}
